import { render } from "./StatusPage.vue?vue&type=template&id=f4b974be&ts=true"
import script from "./StatusPage.vue?vue&type=script&lang=ts"
export * from "./StatusPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__